import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { conversionEvents, otherEvents } from '../../shared/tracking';

interface ActionEmailProps {
  email: string;
  trackerConversion: (event: string) => void;
  trackerOther: (event: string) => void;
}

const ActionEmail = ({ email, trackerConversion, trackerOther }: ActionEmailProps) => {
  const { t } = useTranslation(['retailer']);
  const [visible, setVisible] = useState(false);

  const onClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (visible) {
      trackerOther(otherEvents.CONVERSION_MAIL_SENT_RETAILER);
    } else {
      e.stopPropagation();
      e.preventDefault();
      setVisible(true);
      trackerConversion(conversionEvents.MAIL_VISIBLE_RETAILER);
    }
  };

  if (visible) {
    return (
      <li className="m-b">
        <a
          href={`mailto:${email}`}
          title={t('emailUs', { ns: 'retailer' })}
          data-am-button="primary-clear no-padding text-left text-regular square"
          onClick={onClick}
        >
          <div className="table">
            <div className="td td-minimal valign-middle">
              <div data-am-icon="primary">
                <i className="icon-email" />
              </div>
            </div>
            <div className="td valign-middle p-l-half">
              <div className="font-regular text-dark-lighten font-size-small m-b-mini">
                {t('emailUs', { ns: 'retailer' })}
              </div>
              <div>{email}</div>
            </div>
          </div>
        </a>
      </li>
    );
  }

  return (
    <li className="m-b">
      <button
        type="button"
        title={t('showEmailAddress', { ns: 'retailer' })}
        data-am-button="primary-clear no-padding text-left text-regular square"
        onClick={onClick}
      >
        <div className="table">
          <div className="td td-minimal valign-middle">
            <div data-am-icon="primary">
              <i className="icon-email" />
            </div>
          </div>
          <div className="td valign-middle p-l-half">
            <div>{t('showEmailAddress', { ns: 'retailer' })}</div>
          </div>
        </div>
      </button>
    </li>
  );
};

export default ActionEmail;
